<template>
    <div class="page-modal">
        <widgetModal title="Update Account Tags" :subtitle="content && content.length > 0 ?
            `Manage tags for ${content.length} selected account${content.length > 1 ? 's' : ''}` :
            'Manage tags for the selected accounts'" btnlefttext="Save Changes" btncentertext="Cancel"
            :leftloading="updating_loading" :centerloading="false" :footerhidden="false" :hiderightbtn="true"
            footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px" body_padding="0px 30px"
            width="500px" @onLeftClick="onConfirm()" @onCenterClick="onCancel">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="Tags">
                        <widgetTags v-if="tagsLoaded" v-model="tags" placeholder="Add tags" input_width="100%"></widgetTags>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>
    </div>
</template>

<script>
export default {
    name: "update-account-tags-modal",
    props: {
        content: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            tags: {
                added: [],
                removed: [],
            },
            initialTags: [], // Track initial tag names to identify removals
            initialTagsWithIds: [], // Track initial tags with IDs
            updating_loading: false,
            tagsLoaded: false
        };
    },
    computed: {},
    mounted() {
        let vm = this;
        vm.loadExistingTags();
    },
    watch: {
    },
    methods: {
        loadExistingTags() {
            let vm = this;
            // Collect all unique tags from selected accounts
            const tagsMap = new Map();

            vm.content.forEach(account => {
                if (account.tags && Array.isArray(account.tags)) {
                    account.tags.forEach(tag => {
                        // Use tag name as key to avoid duplicates
                        const tagName = tag.name || tag;
                        const tagId = tag.id || tagName;
                        if (tagName && !tagsMap.has(tagName)) {
                            // Create a copy with on_update flag to track removals
                            const tagCopy = {
                                name: tagName,
                                id: tagId,
                                on_update: true
                            };
                            tagsMap.set(tagName, tagCopy);
                        }
                    });
                }
            });

            // Populate tags.added with existing tags and store initial state
            const existingTags = Array.from(tagsMap.values());
            vm.initialTags = existingTags.map(tag => tag.name || tag);
            vm.initialTagsWithIds = [...existingTags];
            
            // Set tags after storing initial state
            vm.tags = {
                added: existingTags,
                removed: []
            };
            
            // Set flag to render widgetTags after data is ready
            vm.$nextTick(() => {
                vm.tagsLoaded = true;
            });
        },
        onConfirm() {
            let vm = this;

            // Get current tag names (remove duplicates)
            const currentTagNames = [...new Set(vm.tags.added.map(tag => tag.name || tag))];
            
            // Find newly added tags (not in initial tags)
            const newlyAddedTags = currentTagNames.filter(tagName => !vm.initialTags.includes(tagName));
            
            // Find removed tags (in initial tags but not in current tags)
            const removedTags = [];
            vm.initialTags.forEach(initialTagName => {
                if (!currentTagNames.includes(initialTagName)) {
                    // Find the tag ID from initialTagsWithIds
                    const initialTag = vm.initialTagsWithIds.find(t => (t.name || t) === initialTagName);
                    if (initialTag && initialTag.id) {
                        removedTags.push(initialTag.id);
                    } else {
                        // Use the name if no ID found (fallback)
                        removedTags.push(initialTagName);
                    }
                }
            });
            
            // Check if there are any changes (newly added or removed tags)
            if (newlyAddedTags.length === 0 && removedTags.length === 0) {
                vm.$notify({
                    group: "status",
                    title: "Message",
                    text: "Please add or remove at least one tag",
                    type: "warn",
                    duration: 3000,
                });
                return;
            }

            vm.updating_loading = true;

            // Get IDs of selected accounts
            const accountIds = vm.content.map(account => account.id);

            vm.$store
                .dispatch("ACCOUNT_UPDATE_TAGS", {
                    ids: accountIds,
                    tags_added: newlyAddedTags,
                    tags_removed: removedTags
                })
                .then((response) => {
                    vm.updating_loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Account tags updated successfully",
                        type: "success",
                        duration: 3000,
                    });
                    vm.$emit("success");
                })
                .catch((error) => {
                    vm.updating_loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong",
                        type: "warn",
                        duration: 3000,
                    });
                    console.error({ error });
                });
        },
        onCancel() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.page-modal {
    .widget-modal-body-noscoll {
    }
}
</style>

